import { CSSProperties, FC, ReactNode } from 'react';

import { cn } from '../../../utils';

interface Props {
    readonly colors: string[];
    readonly className?: string;
    readonly children?: ReactNode;
}

const backgroundFor = (colors: string[]): CSSProperties['background'] => {
    if (colors.length < 2) return colors[0] ?? '#64748b';

    const segmentSize = 100 / colors.length;
    const stops = colors.flatMap((color, index) => [
        `${color} ${index * segmentSize}%`,
        `${color} ${(index + 1) * segmentSize}%`,
    ]);

    return `conic-gradient(from -45deg, ${stops.join(', ')})`;
};

export const ColorSegmentsIcon: FC<Props> = ({
    colors,
    className,
    children,
}) => (
    <span
        aria-hidden="true"
        className={cn(
            'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full shadow-[0_0_0_1px_rgba(15,23,42,0.22),0_2px_4px_rgba(15,23,42,0.28)] dark:shadow-[0_0_0_1px_rgba(255,255,255,0.28),0_2px_5px_rgba(0,0,0,0.55)]',
            className,
        )}
        style={{ background: backgroundFor(colors) }}
    >
        {children}
    </span>
);
